module.exports = __webpack_public_path__ + "static/media/muselogo.d212e318.svg";